import React                from 'react';
import { useSelector }      from "react-redux";
import { ApplicationState } from "../../../store";
import { APIState }         from "../../../store/API/types";
import SelectComponent      from "../../reusable/SelectComponent";
import './style.scss';


type BkmExportFormType = {
  classification: string,
  caseName: string,
  tags: string,
  comments: string
}

interface Props {
  onChange: (name: string, value: string) => void,
  classification: string,
  classifications: { name: string, id: number }[],
  cases: string[],
  caseName: string,
  tags: string,
  comments: string
}


const BkmFormForExportComponent: React.FC<Props> = ({onChange, classification, caseName, tags, comments, classifications, cases}) => {
  const {bkmsInfo} = useSelector<ApplicationState, APIState>(state => state.API);

  if (!bkmsInfo) return null;

  const casesOptions = cases.map((item: any) => ({value: item.name, label: item.name}));
  casesOptions.unshift({value: '--case--', label: '--case--'});

  return (
    <div className='bkm-form'>
      <div className='bkm-form__1row'>
        <SelectComponent inputs={classifications.map(({name}) => ({value: name, label: name}))}
                         classValue={'select-in-export'}
                         title={'Classification'}
                         name={'Classification'}
                         selected={classification}
                         onSubmit={(e) => onChange('classification', e.target.value)}
        />

        <SelectComponent inputs={casesOptions}
                         classValue={'select-in-export'}
                         title={'Case file'}
                         name={'caseName'}
                         selected={caseName}
                         onSubmit={(e) => onChange('caseName', e.target.value)}
        />
      </div>
      <div className={'bkm-form__1row'}>
        <div className={'bkm-form__textarea'}>
                     <textarea name='tags'
                               placeholder='tags'
                               value={tags}
                               onChange={(e) => onChange('tags', e.target.value)}/>
        </div>
        <div className={'bkm-form__textarea'}>
                    <textarea value={comments}
                              placeholder='comments'
                              onChange={(e) => onChange('comments', e.target.value)}/>
        </div>
      </div>
    </div>
  );
};

export default BkmFormForExportComponent;